import { PREFERENCE_CENTER_MERGE_TOKEN } from "./mergeFieldTokens";
/**
 * CONSTRAINT: this grammar must stay identical to `MailjetVariableHelper.CatalogTokenRegex` in
 * opink — the send gate here and the send guard there must agree on what counts as a token, or the
 * user is refused for something the server accepts, or waved through for something it rejects.
 * Neither side can import the other, so the contract is pinned by two mirrored suites: the cases
 * below and `MailjetVariableHelperCatalogTests.ConvertToMailjetVariables_TokenGrammar_IsTheOneTheFrontendAuditMirrors`.
 * Widen one regex without widening the other and that side's suite fails.
 */
export const MERGE_TOKEN_PATTERN = /\{\{(?!var:)([a-z0-9_]+)\}\}/gi;
/**
 * The mandatory pre-send rules (OP-5630), as pure functions over the compiled HTML.
 *
 * Single source of truth: the in-editor Unlayer audit (`useContentAudit`) and the send gate
 * (`useCampaignEditorStore.preSendWarnings`) live on different routes and would otherwise drift.
 * Keep this module free of Vue, i18n and Unlayer.
 */
export function auditContentHtml(html, { emailType, catalogueKeys }) {
    if (!html)
        return [];
    const findings = [];
    if (emailType === "Marketing" && !html.includes(PREFERENCE_CENTER_MERGE_TOKEN)) {
        findings.push({ ruleId: "MISSING_PREFERENCES_LINK" });
    }
    // Fail-open: an empty catalogue means it has not loaded, not that every token is invalid.
    // Reporting them all would refuse every send after a transient catalogue fetch failure.
    if (catalogueKeys.size > 0) {
        const reported = new Set();
        for (const match of html.matchAll(MERGE_TOKEN_PATTERN)) {
            const token = match[1].toLowerCase();
            if (reported.has(token) || catalogueKeys.has(token))
                continue;
            reported.add(token);
            findings.push({ ruleId: "UNKNOWN_MERGE_FIELD", token });
        }
    }
    return findings;
}
